import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Typography,
  Chip,
  Container,
  Grid,
  Card,
  Box,
  Button,
} from "@mui/material";
import Map from "../extra/Map";
import { DASHBOARD, PROJECT, CAMERAINFO, SYSTEMINFO } from "../../services/actions";
import ProgressBar from "../extra/ProgressBar";

const cs = {
  width: 40,
  height: "100%",
  background: "#227d52",
  borderRadius: 100,
  position: "relative",
};
const csz = {
  ...cs,
  backgroundImage:
    "repeating-linear-gradient(135deg, gray 0px, gray 2px, white 0px, white 4px)",
};

const covertSStoHHMM = (image_gap_seconds) => {
  const hours = Math.floor(image_gap_seconds / 3600);
  const minutes = Math.floor((image_gap_seconds % 3600) / 60);
  const hhmm = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  return hhmm  // Outputs: 00:06
}
function Info({ data, onStatusChange }) {
  const [online, setOnline] = useState("Offline");

  useEffect(() => {
    let img;

    if (data?.camera_type === "Timelapse") {
      const status = data?.is_active ? "Online" : "Offline";
      setOnline(status);
      onStatusChange?.(data.id, status); // send status back
    } else if (data?.url) {
      const status = data?.is_streaming_live ? "Online" : "Offline";
      setOnline(status);
      onStatusChange?.(data.id, status); // send status back
    }

    return () => {
      if (img) {
        img.onload = null;
        img.onerror = null;
      }
    };
  }, [data]);

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 8,
        boxShadow: 0,
      }}
    >
      <Box display={'flex'}>
        <Box sx={{ width: 1 }}>
          <Typography fontWeight={800} fontSize={13}>{data.name}</Typography>
          <Typography fontWeight={700} fontSize={12}>{data.project}</Typography>
          <Typography fontWeight={700} fontSize={11}>{data.company}</Typography>
          <Typography fontSize={12} mt={2}>Last Image Received {covertSStoHHMM(data?.image_gap_seconds)} Minutes ago</Typography>
          <Typography fontSize={11}>{data?.camera_type}</Typography>
        </Box>
        <Box>
          <Typography
            className="toggle-status"
            sx={{
              p: 0.5,
              borderRadius: 2,
              color: 'white',
              background: online === 'Offline' ? '#c91d1d' : 'green',
              textAlign: 'center'
            }}
            fontSize={10}
            mb={2}
          >
            {online}
          </Typography>

          {data?.camera_type === "Timelapse" ? (
            <img src={data?.latest_image_path} height="40" style={{ borderRadius: 4 }} alt="" />
          ) : (
            <img src={data.url} height="40" style={{ borderRadius: 4 }} alt="" />
          )}
        </Box>
      </Box>
    </Card>
  );
}


export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user = useSelector((state) => state?.loginState?.auth)
  const cameraInfoState = useSelector((state) => state.camerainfoState)
  const systemInfoState = useSelector((state) => state.systeminfoState)
  const [statusMap, setStatusMap] = useState({});
  let onlineCount = 0;
  let offlineCount = 0;
  const [loading, setLoading] = useState(false);

  const handleStatusUpdate = (id, status) => {
    if (status === "Online") onlineCount++;
    else if (status === "Offline") offlineCount++;
    setStatusMap(prev => ({ ...prev, [id]: status, onlineCount, offlineCount }));
    if (onlineCount + offlineCount == cameraInfoState?.data?.results?.length) {
      setLoading(false)
    }
  };
  useEffect(() => {
    dispatch({ type: `${CAMERAINFO}_GET`, payload: 0 });
    setLoading(true)
  }, [dispatch]);


  const getLocations = (datas) => {
    let ds = datas.map((d) => { return { latlng: d.camera_location.split(","), desc: d.camera_name } })
    return ds.filter((d) => d.latlng.length >= 2)
  }

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      {/* Dashboard Cards */}
      <h1>  Camera Status</h1>
      <Card sx={{ background: 'white', p: 2, borderRadius: 2, mb: 2 }}>
        {loading ? <ProgressBar /> :
          <Box sx={{ borderRadius: 2, mb: 1, display: 'flex', gap: 3, mt: 2, flexWrap: 'wrap' }}>
            <Chip sx={{ color: 'blue' }} label={`Total Camera: ${cameraInfoState?.data?.results?.length}`}></Chip>
            <Chip sx={{ color: 'green' }} label={`Online Camera: ${statusMap.onlineCount}`}></Chip>
            <Chip sx={{ color: 'red' }} label={`Offline Camera: ${statusMap.offlineCount}`}></Chip>
          </Box>}
      </Card>

      <Grid container spacing={2} mb={2}>
        {(cameraInfoState?.data?.results || []).map((data, i) => {
          let url = data?.previous_image_path
          if (data?.camera_type == 'Network') {
            url = `${data?.ip}/jpg/image.jpg`
          }
          data.url = url
          return (
            <Grid className="toggle-card" size={{ xs: 12, md: 4 }} key={i}>
              <Info data={data} onStatusChange={handleStatusUpdate} />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}
